import { useState } from "react";
import { Button, Card, Container, Tab, Tabs } from "react-bootstrap";
import ExpenditureForecast from "../expenditure-forecast";
import EstimatedBudgetCeiling from "../estimated-budget-ceiling";
import DownloadReports from "../download-reports";
import LoginModal from "../../components/LoginModal";

const Component = () => {
  const [key, setKey] = useState<string>("");
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [showLoginModal, setShowLoginModal] = useState<boolean>(true);

  const handleLogin = (apiKey: string) => {
    setKey(apiKey);
    setIsAuthenticated(true);
    setShowLoginModal(false);
  };

  const handleLogout = () => {
    setKey("");
    setIsAuthenticated(false);
    setShowLoginModal(true);
  };

  return (
    <>
      <LoginModal show={showLoginModal} onLogin={handleLogin} />

      <Container>
        <Card style={{ minHeight: "90vh", height: "90vh", overflowY: "auto" }}>
          <Card.Header>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">LIC Report System</h5>
              <div className="d-flex align-items-center gap-2">
                <span className="text-success">✓ Authenticated</span>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleLogout}>
                  Logout
                </Button>
              </div>
            </div>
          </Card.Header>

          <Card.Body>
            {isAuthenticated ? (
              <Tabs defaultActiveKey="reports" id="main-tabs" className="mb-3">
                <Tab eventKey="reports" title="Download Reports">
                  <DownloadReports apiKey={key} />
                </Tab>
                <Tab eventKey="forecast" title="Expenditure Forecast">
                  <ExpenditureForecast apiKey={key} />
                </Tab>
                <Tab eventKey="budget-ceiling" title="Budget Ceiling">
                  <EstimatedBudgetCeiling apiKey={key} />
                </Tab>
              </Tabs>
            ) : (
              <div className="text-center p-5">
                <h4>Please authenticate to access the application</h4>
                <p className="text-muted">
                  Click the login button above to enter your API key.
                </p>
                <Button
                  variant="primary"
                  onClick={() => setShowLoginModal(true)}
                  size="lg">
                  Login
                </Button>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default Component;
